<img class="image" src="assets/icons/features/feature_icon.svg" alt=""/>
<p class="text">{{ content }}</p>
